(function($){
    $(document).ready(function() {
        let inputBoxTypes = "input, select, textarea";
        let shippingLength = "shipping_".length;

        // Add in hack to override val function to make it work properly with addons (such as saved addresses)
        let originalVal = $.fn.val;
        $.fn.val = function(){
            let result = originalVal.apply(this,arguments);
            if(arguments.length > 0 && $(this).attr("id") && $(this).attr("id").indexOf("shipping_") === 0) {
                $(this).change(); // OR with custom event $(this).trigger('value-changed');
            }
            return result;
        };

        // For every kind of input on the shipping side of things, try and
        // keep in sync with billing
        $(inputBoxTypes, ".woocommerce-shipping-fields__field-wrapper").on("change keyup update", function () {
            if (!$("#bill-to-different-address-checkbox").prop('checked')) {

                // Update the value on the billing side
                $("#billing_" + $(this).attr("id").substr(shippingLength)).val($(this).val());
            }
        }).trigger('change');
        // We trigger at the end in case of reloaded fields

        $("#bill-to-different-address-checkbox").on("change", function () {
            validate_address_checkbox_switcher();
        }).trigger('change');

        $('.js-checkout-step').on('click', function (){
            validate_address_checkbox_switcher();
        });

        function validate_address_checkbox_switcher(){
            let isChecked = $("#bill-to-different-address-checkbox").prop("checked");
            let woocommerce_billing_fields = $('#woocommerce-billing-fields');

            // Now go through every shipping field
            $(inputBoxTypes, ".woocommerce-shipping-fields__field-wrapper").each(function () {
                let id = $(this).attr("id").substr(shippingLength);

                if (isChecked) {
                    woocommerce_billing_fields.show(300);
                    $("#billing_" + id).val('');
                } else {
                    woocommerce_billing_fields.hide(300);

                    // We need to set the value to the shipping value
                    $("#billing_" + id).val($(this).val());
                }
            });
        }
    });
})(jQuery);